// extracted by mini-css-extract-plugin
module.exports = {"headerCompactSpacing":"cpf-not-verified_headerCompactSpacing__6TrE6","supportLink":"cpf-not-verified_supportLink__JLMJJ"};